import Bagus from "../../Images/ourTeam/Bagus.png";
import Derlina from "../../Images/ourTeam/Derlina.png";
import Tety from "../../Images/ourTeam/Tety.png";
import Fransisca from "../../Images/ourTeam/Fransisca.png";
import Malki from "../../Images/ourTeam/Malki.png";
import Amerlina from "../../Images/ourTeam/Amerlina.png";
import Evy from "../../Images/ourTeam/Evy.png";
import Syafrudin from "../../Images/ourTeam/Syafrudin.png";
import Ikrar from "../../Images/ourTeam/Ikrar.png";
import Seni from "../../Images/ourTeam/Seni.png";
import Bhara from "../../Images/ourTeam/bhara.png";

export default [
  {
    name: "Bagus F. Asyhari",
    image: Bagus,
    role: "Founder",
    role1: "Pendiri",
    linkedin: "www.linkedin.com",
  },
  {
    name: "Derlina Yusuf",
    image: Derlina,
    role: "Managing Director",
    role1: "Direktur pengatur",
    linkedin: "www.linkedin.com",
  },
  {
    name: "Tety Kartikasari",
    image: Tety,
    role: "HRGA Director",
    role1: "Direktur HRGA",
    linkedin: "www.linkedin.com",
  },
  {
    name: "Fransisca Retno",
    image: Fransisca,
    role: "Business Development",
    role1: "Pengembangan Bisnis",
    linkedin: "www.linkedin.com",
  },
  {
    name: "Malki Jaehanto",
    image: Malki,
    role: "Head of Production",
    role1: "Kepala Produksi",
    linkedin: "www.linkedin.com",
  },
  {
    name: "Amerlina H. L.",
    image: Amerlina,
    role: "Strategic Planning",
    role1: "Perencanaan strategis",
    linkedin: "www.linkedin.com",
  },
  {
    name: "Evy Ariza",
    image: Evy,
    role: "General Affair",
    role1: "Urusan Umum",
    linkedin: "www.linkedin.com",
  },
  {
    name: "Syafrudin Asyhari",
    image: Syafrudin,
    role: "Production Specialist",
    role1: "Spesialis Produksi",
    linkedin: "www.linkedin.com",
  },
  {
    name: "Ikrar H. Mahardhika",
    image: Ikrar,
    role: "Head of Marketing",
    role1: "Kepala Pemasaran",
    linkedin: "www.linkedin.com",
  },
  {
    name: "Seni Iriani Loka",
    image: Seni,
    role: "Head of Digital & Partnership",
    role1: "Kepala Digital & Kemitraan",
    linkedin: "www.linkedin.com",
  },
];
